export default __webpack_public_path__ + "static/media/Flag.c4d2e5d0.svg";